module.exports = __webpack_public_path__ + "static/training2-7d941a2ee0051b4df924cf78d47bd360.jpg";